import React from 'react';
import './styles.scss';
import {
  useConfigStore,
  useInterfaceStore,
  useChatStore,
} from '@/hooks/stores';
import { Avatars } from '../Avatars';
import { Icon } from '../Icon';
import { VIEW } from '@/types';
import { useCustomComponent } from '@/hooks';
import Components from './components';

export const HeaderComponent = () => {
  const { widgetActiveView, widgetIsOpen, toggleWidgetOpen, isInlineMode } =
    useInterfaceStore();
  const { isFormSubmitting } = useChatStore();
  const {
    features: { home, enableHomeTab },
    theme: {
      branding: { logo },
      colors,
    },
  } = useConfigStore();

  const Logo = () => (
    <Components.HeaderLogo
      url={logo?.url}
      alt={logo?.alt}
      width={logo?.width}
      height={logo?.height}
      position={logo?.position}
    />
  );

  // Only show header titles when home tab is enabled and widget is on HOME view
  const titlesVisible =
    enableHomeTab && widgetActiveView === VIEW.HOME && widgetIsOpen;

  return (
    <Components.Container>
      <Components.HeaderRoot>
        <Components.HeaderContent logoPosition={logo.position}>
          <Logo />
          <Avatars />
        </Components.HeaderContent>
        {!isInlineMode && (
          <Components.HeaderCloseButton
            onClick={toggleWidgetOpen}
            disabled={isFormSubmitting}
            style={{ backgroundColor: colors.neutrals.primary['750'] }}
          >
            <Icon name="Crossmark" color={colors.primary} />
          </Components.HeaderCloseButton>
        )}
      </Components.HeaderRoot>
      <Components.HeaderTitles
        visible={titlesVisible}
        title={home.header.title}
        subtitle={home.header.subtitle}
      />
    </Components.Container>
  );
};

export const Header: React.FC = props => {
  const Component = useCustomComponent({
    componentName: 'Header',
    Component: HeaderComponent,
  });

  return <Component {...props} />;
};
